import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ApplicationsService } from '../applications.service';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { FormControl } from '@angular/forms';
import { DialogEventEnum } from 'app/ui/dialog/dialog-event.enum';

@Component({
    selector: 'create-application',
    templateUrl: 'create-application.component.html',
    styleUrls: ['create-application.component.scss']
})
export class CreateApplicationComponent implements OnInit {

    name: string;

    @ViewChild('nameInput')
    nameInput: ElementRef;

    isLoading = false;

    constructor(
        private applicationsService: ApplicationsService,
        private dialogService: UIDialogService,
        private userSettingsService: UserSettingsService) {
    }

    ngOnInit(): void {
        this.nameInput.nativeElement.focus();
    }

    async create(form: FormControl) {

        if (form.invalid) {
            return;
        }

        this.isLoading = true;
        try {
            await this.applicationsService.createApplication(this.name, this.userSettingsService.serviceType).toPromise();
            this.dialogService.close(DialogEventEnum.save);
        } catch (error) {
            console.error(error);
            this.isLoading = false;
        }
    }

    cancel() {
        this.dialogService.close();
    }

}
